/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersPreferencesTechnicalSettingsStatus200, GetUsersPreferencesTechnicalSettingsStatus204, GetUsersPreferencesTechnicalSettingsStatus401 } from '../types/GetUsersPreferencesTechnicalSettings'
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query'
import { getUsersPreferencesTechnicalSettings } from '../clients/getUsersPreferencesTechnicalSettings'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

export const getUsersPreferencesTechnicalSettingsSuspenseQueryKey = () => [{ url: '/users/preferences/technical-settings/' }] as const

type GetUsersPreferencesTechnicalSettingsSuspenseQueryKey = ReturnType<typeof getUsersPreferencesTechnicalSettingsSuspenseQueryKey>

export function getUsersPreferencesTechnicalSettingsSuspenseQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUsersPreferencesTechnicalSettingsSuspenseQueryKey()
  return queryOptions<GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, ResponseErrorConfig<GetUsersPreferencesTechnicalSettingsStatus401>, GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getUsersPreferencesTechnicalSettings({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /users/preferences/technical-settings/}
 */
export function useGetUsersPreferencesTechnicalSettingsSuspense<TData = GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, TQueryKey extends QueryKey = GetUsersPreferencesTechnicalSettingsSuspenseQueryKey>(options: {
  query?: Partial<UseSuspenseQueryOptions<GetUsersPreferencesTechnicalSettingsStatus200 | GetUsersPreferencesTechnicalSettingsStatus204, ResponseErrorConfig<GetUsersPreferencesTechnicalSettingsStatus401>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersPreferencesTechnicalSettingsSuspenseQueryKey()

  const queryResult = useSuspenseQuery({
   ...getUsersPreferencesTechnicalSettingsSuspenseQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetUsersPreferencesTechnicalSettingsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
